/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.membership.detail.datePicker.controllers', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.service.helpers',
  'acme.common.service.userPreferences',
  'acme.common.service.datePickerNote'
])
.controller('MembershipDetailDatePickerController', ['$scope', '$rootScope', '$timeout', 'HelpersService', 'DatePickerNoteService', 'UserPreferencesService', function($scope, $rootScope, $timeout, HelpersService, DatePickerNoteService, UserPreferencesService) {

  $scope.membershipDetailDatePicker = {

    isOpen: false,

    isPreferenceLoaded: false,

    datepickerModule: {},
    dateFormat: UserPreferencesService.getDateFormat('shortDate', 'dateFormat'),
    dateOptions: {
      formatYear: 'yy',
      startingDay: UserPreferencesService.getStartDayOfWeek(),
      formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat'),
      showWeeks: false
    },

    init: function() {

      this.today();
      $scope.initDate = new Date('2016-15-20');
      $scope.formats = ['M/d/yy','dd/MM/yyyy', 'dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'yyyyMMdd', 'shortDate'];
      $scope.format = $scope.formats[0];
      $scope.$on('UserPreferencesService:onDateFormatLoad', this.onDateFormatLoad);
      $scope.$on('MembershipDetailDatePickerController::DatePickerNote', this.onDatePickerNote);
      $scope.$on('MembershipDetailDatePickerController::Close', this.onDatePickerClose);
      $timeout(function () {
        var self = $scope.membershipDetailDatePicker;
        $scope.membershipDetailDatePicker.isPreferenceLoaded = true;
        // Datepicker inner module ref
        self.datepickerModule = $scope.$$childTail;
      },0);
    },

    today: function() {
      this.dt = new Date();
    },

    clear: function () {
      $scope.dt = null;
    },

    toggleMin: function() {
      $scope.minDate = $scope.minDate ? null : new Date();
    },

    open: function($event) {
      $event.preventDefault();
      $event.stopPropagation();

      this.isOpen = true;
    },

    getDateFormat: function() {
      return this.dateFormat;
    },

    onDateFormatLoad: function (e, data) {
      var self = $scope.membershipDetailDatePicker;
      self.dateFormat  = 'M!/d!/yyyy';
      self.dateOptions = {
        formatYear: 'yy',
        startingDay: UserPreferencesService.getStartDayOfWeek(),
        formatDayTitle: UserPreferencesService.getDateFormat('month', 'dateFormat')
      };
    },

    onDatePickerNote: function(e, data) {
      DatePickerNoteService.update(data.id, data.note, $scope.membershipDetailDatePicker.datepickerModule);
    },

    onDatePickerClose: function(e, data) {
      $scope.membershipDetailDatePicker.isOpen = false;
    }

  };

  $scope.membershipDetailDatePicker.init();

}]);